export const OPPORTUNITY_TRACK_ROLE = {
    ORGANIZER: 'ORGANIZER',
    MEMBER: 'MEMBER',
    REVIEWER: 'REVIEWER'
}